import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Saga } from 'custom-types/saga';
import { fetchJobsTableData } from 'api/JobsAPI';
import { addToRootSaga } from 'store';
import { JobAction, JobTableData } from 'modules/jobManager/types';
import { ActionTypes } from 'modules/jobManager/ducks/actionTypes';
import * as actions from 'modules/jobManager/ducks/actions';
import { addNegativeToast } from 'modules/toastContainer';
import {
  getJobManagerTableFilter,
  getJobManagerTablePagination,
  getJobManagerTableSort,
} from '../selectors';

export function* fetchJobTableDataSaga(): Saga<JobAction<Record<string, unknown>, JobTableData>> {
  try {
    const filterInfo = yield select(getJobManagerTableFilter);
    const { pageSize, page } = yield select(getJobManagerTablePagination);
    const sort = yield select(getJobManagerTableSort);
    const queryData = {
      filterInfo,
      pagination: {
        limit: pageSize,
        offset: (page - 1) * pageSize,
      },
      sort,
    };
    const {
      data: { jobs },
    } = yield call(fetchJobsTableData, queryData);

    yield put(actions.fetchJobTableDataResponse(jobs));
  } catch (e) {
    yield put(actions.fetchJobTableDataError());
    yield put(addNegativeToast('Failed to get the list of jobs') as any);
  }
}

addToRootSaga([takeLatest(ActionTypes.FETCH_TABLE_DATA_REQUEST, fetchJobTableDataSaga)]);
